export default {
  Andpenalties: 'Liquidated Damages and Penalties',
  DeliveryFailed: 'Delivery failed, refunds are borne by Party A',
  abandonedRequests: 'Abandoned Order',
  abandonedorder: 'Abandoned Order',
  accesshelpcenter: 'Access our help center',
  accessoriesLessDelivery:
    'Lack of accessories, less delivery, refunds are borne by Party A',
  accesstoken: 'Access Token',
  accessurlexample: 'Example: your-store.com',
  accessurlprefix:
    'The URL cannot contain the following values: www., https://, http://, /',
  actions: 'Actions',
  activate: 'activate',
  activateStore:
    'If you are going to use our Online Store, activate it to release all DNS Records.',
  active: 'ACTIVE',
  active2: 'Active',
  actuallyPrice: 'Actually Price',
  addDomainTips1: 'Link a domain that already belongs to you.',
  addDomainTips2:
    'You can also link a subdomain. Please make sure to start your form with "pay" or "pago". Ex.:',
  addDomainTips3: 'Do not use',
  addDomainTips4: 'Keep an eye out! in order for your domain to work,',
  addDomainTips5: 'you need to purchase and set it up with a hosting service',
  addDomainTips6: 'or another.',
  addDomainTips7: 'If you have any questions, please consult our',
  addPopup: 'Add Coupon',
  addastore: 'Add a Store',
  addstore: 'Add Store',
  afterEachSuccessful: `After each successful transaction of Party B, Party A will withdraw 5% of the successful transaction amount of Party B, and keep the revolving margin in Party A's account while transferring it to Party B. The revolving margin in Party A's account for each transaction will be kept for 45 days, and the amount will be released to Party B after 45 days.`,
  afterSales:
    'This is the after-sales mailbox. Customers send after-sales questions to this mailbox, and the after-sales team will reply.',
  afterVerification:
    'If the refund reason falls into the following five situations after verification, the refund will be borne by Party B',
  agreetoNY: '"By creating an account, you agree to USAdrop\'s"',
  alreadyhaveanaccount: 'Already have an account?',
  and: 'and',
  apikey: 'Api Key / Client ID',
  apisecretkey: 'API secret key / Secret',
  ativo: 'ACTIVE',
  backgroundColor: 'Background Color',
  basicinformation: 'Basic information',
  blacklisted:
    'If the customer is blacklisted, the refund shall be cancelled and borne by Party B',
  blacklistedCustomer: 'Blacklisted customer, cancel refund',
  borneByParty: `Due to Party B's failure to pay in time, the customer requests to cancel the order, and the refund shall be borne by Party B`,
  borneParty:
    'If the product is not satisfactory (does not like it), the refund shall be borne by Party A',
  buttonText: 'Button Text',
  cancel: 'cancel',
  cancellationAnd:
    'If the order is not shipped and the customer requests cancellation and refund, the refund shall be borne by Party B',
  cardPaymentsAnswer:
    'Once the customer pays into our account, it will be transferred to your wallet the next day.',
  cardPaymentsTitile:
    'How long does it take for the amount to be transferred to my account after customers place orders?',
  carddesc: 'CARDS,BOLETO, BANK DEPOSIT AND PIX',
  changeAddress:
    'For requests to change the address after the goods have been shipped, the refund shall be borne by Party B',
  classic: 'Classic',
  collaboratorRequestCode:
    'Store collaborater permissions and codes（Our email is _email_, please process the permission）',
  collapsemenu: 'Collapse menu',
  confirm: 'Confirm',
  confirmedAndThe:
    'If the order is to be confirmed and the customer does not reply for more than 2 days, the refund shall be borne by Party B',
  confirmpassword: 'Confirm your password',
  contentTerms: 'Content Terms',
  convertedOrderPaid: 'Converted Order (Paid)',
  convertedOrderUnpaid: 'Converted Order (Unpaid)',
  copy: 'copy',
  correspondingPenalties: `Party B must comply with laws and regulations as well as Party A and the card organization's risk management requirements for illegal transactions. If Party B violates any of these regulations, Party B will be subject to corresponding penalties and fines.`,
  countdownImage: 'Countdown Image',
  countdownTimer: 'Countdown Timer',
  countdownBg: 'Countdown BackgroundColor',
  countdownTextColor: 'Countdown TextColor',
  country: 'Country',
  coupon: 'Coupon',
  couponCode: 'Discount code (optional)',
  creatanaccount: 'Create an account',
  createTime: 'Create Time',
  createaccounttitle:
    'Create your free account on our Basic plan, with no monthly fees.',
  createfreeaccount: 'Create free account',
  createpassword: 'Create a password',
  currencyConversionAnswer:
    'Convert based on the official exchange rate provided by the payment provider',
  currencyConversionTitle: 'Currency conversion issues？',
  currentStoreName: 'Current store:',
  customerBuysMore:
    'If the customer buys more and wants to cancel and refund, the refund shall be borne by Party B',
  date: 'Date',
  days: 'days',
  defaultDomainTips:
    '"This is the free domain provided by USAdrop. Itll always work. But we indicate setting up your own."',
  delete: 'Delete',
  deleteSelected: 'DELETE SELECTED',
  deleteSuccess: 'Deletion successful!',
  deletedSuccessfully: 'Deleted successfully',
  deliveryTime:
    'The customer receives the goods, the delivery time is too long, exceeding the store time limit, refunds are borne by Party A',
  disable: 'Disable',
  disabledSuccessfully: 'Disabled successfully',
  discount: 'Discount',
  discountAmount: 'Discount Amount',
  discountPercent: 'Discount Percent',
  discountRate: 'Discount settings',
  dnsNormal: 'DNS record configuration is normal',
  dnsNotConfigured: 'DNS record not configured or not propagated.',
  dnsRecordsTitle: 'DNS records for your online store',
  domain: 'Domain',
  domainbtntext: 'Set up',
  domaintitle: 'Set up the same domain as your Shopify store here.',
  eachSuccessfulTransaction: `After each successful transaction of Party B, Party A will withdraw 10% of the successful transaction amount of Party B, and keep the revolving margin in Party A's account while transferring it to Party B. The revolving margin in Party A's account for each transaction will be kept for 45 days, and the amount will be released to Party B after 90 days.`,
  edit: 'Edit',
  editstore: 'Edit Store',
  email: 'E-mail',
  emailContent: 'Email Content',
  emailReminders: 'Promotional Setting',
  emailRemindersDesc: 'Set up email reminders and order discounts',
  emailTemplateConfig: 'Email Template Configuration',
  emailTemplateConfigDesc: 'Custom Email Content',
  emailTitle: 'Email Subject',
  embedPaymentMethods:
    'Use emails to urge customers to complete payment at different times to increase order conversion rates.',
  emptyCouponDesc:
    'After configuring the coupon, a popup for claiming the coupon will appear after completing payment, encouraging the user to use the coupon for a better deal.',
  emptyCouponTitle: 'Configure your coupon',
  enable: 'Enable',
  enableCouponTips:
    'Only one coupon can be active at a time. Please disable other coupons before proceeding!',
  enabledSuccessfully: 'Enabled successfully',
  end: 'End',
  endDate: 'End date',
  enter: 'Enter',
  entercorrectemail: 'Please enter the correct email format',
  enteremailandpassword: 'Enter your email and password',
  example: 'Example',
  faqs: 'FAQs',
  firstPaymentChannel: 'Payment Method for First Order',
  firsttimeaNY: 'First time at USAdrop?',
  followInstructions: 'Follow the instructions',
  followingPenalties:
    'In addition to the above-mentioned fines, those who violate the regulations seriously will face the following penalties:',
  forBrazil: 'For Brazil：',
  forMexico: 'For Mexico/Chile/Colombia/Peru：',
  forPaymentFailure:
    'For payment failure, the refund shall be borne by Party B',
  forShopify:
    'When you sign up for Shopify, your online store is given a "myshopify.com" URL.',
  forgetpassword: 'I forget my password',
  fullname: 'Full name',
  goodsNum: 'items',
  gtm: 'Code (GTM-XXXXXXX)',
  gtmRequired: 'Container ID is required',
  gtmDomain: 'Server container URL',
  gtmDomainRequired: 'Server container URL is required',
  googleid: 'Measurement ID',
  googlekey: 'Measurement Protocol API secrets',
  googleidRequired: 'Measurement ID is required',
  googlekeyRequired: 'Measurement Protocol API secrets is required',
  hasBeenSigned:
    'Logistics shows that it has been signed, but the customer has not received it, refunds are borne by Party A',
  hasquestions: 'Have questions?',
  headerImage: 'Header Image',
  helpCenter: 'Help Center',
  helpaddress: 'bento.me/enchentesrs',
  hi: 'Hi',
  holding: '1、Holding',
  home: 'Home',
  howtocontribute: 'See how to contribute at',
  howtoset: 'How to set',
  identifyyourself: 'Identify yourself',
  imitationBrand: 'Imitation/imitation brand',
  inActive: 'INACTIVE',
  inativo: 'INATIVO',
  info: 'Information',
  installtitle: 'Install USAdrop Transparent Checkout on your Shopify store.',
  invitationNumber: 'Invitation Code',
  invitationNumberError:
    'Please enter your invitation number to complete your registration',
  isConfirmDelete: 'Are you sure want to delete it？',
  kEmail: 'Email',
  kName: 'Name',
  learnMore: 'learn more.',
  lengthLimit: 'Length should be 3 to 8',
  letteringPattern:
    'Product quality (size, color difference, damage, stains, thread ends, odor, wrinkles, fading, shrinkage, lettering, pattern, logo, accessories), refunds are borne by Party A',
  like: 'like',
  linkNewDomain: 'Link New Domain',
  liquidatedDamages: 'Liquidated Damages and Penalties.',
  logaccount: 'You are logged in to:',
  loginsuccess: 'login success!',
  logout: 'Logout',
  logoutSYS: 'Whether to log out of the system?',
  lougoutsuccess: 'Logout Success!',
  markAsActive: 'Mark as Active',
  markAsInactive: 'Mark as Inactive',
  min: 'min',
  mydomain: 'My domain',
  mydomains: 'My domains',
  mydomainsdesc:
    'Manage your domains here. Link your domains and configure them to be the virtual address of your store and checkout.',
  name: 'NAME:',
  needhelp: 'Rio Grande do Sul needs your help.',
  newaffiliations: 'New Country',
  newpixel: 'New pixel',
  nextPage: 'Next Page',
  backToMessages: 'Back to messages',
  messageDetail: 'Message detail',
  noNotifications: 'No notifications',
  notifications: 'Notifications',
  refresh: 'Refresh',
  no: 'No',
  noDomain: 'No Domain',
  noStatus: 'No Status',
  noUseDefaultDomain: 'Do not use USAdrop default pay domain!',
  noUseOrgin: 'Do not use http:// https:// and www',
  nocountriesavailable: 'No countries available',
  nodatareadtitle: 'Read our full article',
  nodatastartsell: 'When you start selling, your orders will appear here.',
  nodatatip1: 'Customize your store with the look of your business!',
  nodatatip2: 'Offer different payment methods.',
  nodatatip3: 'Add good photos to your products.',
  nodatatip4:
    'Make your product descriptions attractive and use SEO techniques.',
  nodatatip5:
    'Invest in paid traffic: ads on social networks and Google shopping.',
  nodatatip6: 'See if the price of your products is attractive.',
  nodatatip7: 'Have a customer service channel to answer questions',
  nodatatips: '7 quick tips for you to make your first sale:',
  nodatatitle: 'There are no orders to show yet',
  nodeDescription: 'Triggering situation description',
  nodeName: 'Triggering situation',
  operation: 'Status',
  order: 'Order',
  orderCancel: 'Cancelled',
  orderClosed: 'Closed',
  orderConversion: 'Orders Status',
  orderConversionTipUnpaid:
    'Recovered through remarketing, but still unpaid.',
  orderConversionTipUnconverted: 'Never paid by the customer.',
  orderConversionTipPaid:
    'Recovered through remarketing and successfully paid.',
  orderConversionTipPending:
    'Customer initiated payment but did not complete it.',
  orderConversionTipPaidStatus: 'Payment completed successfully.',
  orderDeliver: 'Deliver',
  orderEnd: 'Completed',
  orderPaid: 'Paid',
  orderReceived: 'Delivered',
  orderToAnalyze:
    'In order to analyze the sources of different orders and adjust the advertisements in time, our data is more accurate than that on Facebook.',
  orderWaitPay: 'Pending',
  ordernum: 'Order No',
  more: 'More',
  orderCodesBatchTips: 'Enter one Order No. per line, or separate by commas',
  ordertime: 'Order Time',
  originurl: 'Website Address',
  originurlexample: 'Example: your-store.myshopify.com',
  originurlprefix:
    'The URL cannot contain the following values: www., https://, http://, /, .br',
  package:
    'If the customer refuses to accept the package and requests a refund, The refund shall be borne by Party B',
  partyAProvides:
    'Party A provides a refund guarantee service for cooperative orders at a fee of 1.5%. If the refund reason is verified to be that the customer is dissatisfied with the product after receiving it, the refund fee will be borne by Party A and Party B does not need to bear the related losses. For specific usage scenarios, please refer to the appendix of the system agreement.',
  partyAProvidesconsumers:
    'To safeguard payment stability and compliance, Party A shall be the sole provider of after-sales services for Party B. Party B shall fully authorize Party A to handle all after-sales matters and provide access to the relevant email account(s). Any after-sales by Party B is exceptional and requires Party A’s prior consent, and in such cases, Party B shall grant Party A full access to the relevant after-sales email account(s) for real-time monitoring. Breach of this clause entitles Party A to immediately suspend or terminate B’s access to payment services without liability.',
  partyProvides:
    'Party A provides Party B with cross-border Internet payment and settlement services, including:',
  password: 'Password',
  payBy: 'PAY BY',
  payment: 'Payment',
  paymentDateAnswer:
    'You can apply for withdrawal after paying the order fulfillment fee. The withdrawal will usually be processed within 1-2 working days. The final arrival time depends on your bank.',
  paymentDateTitle:
    'How long does it take for the withdrawal to be received after I initiate it?',
  paymentDomain: 'Domain CNAME Resolve',
  paymentRatesTitle: 'Payment and rates for each country',
  paymentServicesToParty: `Party A provides payment services to Party B, and Party B needs to inform Party A of the store's login information. Party A also provides Party B with relevant transaction information and settlement information query services, and Party B needs to cooperate with Party A to jointly maintain the stability of the payment product account.`,
  paymentSetting: 'Payment Settings',
  paymentTime: 'Payment Time',
  paymentaffiliations: 'Payment Settings',
  paymentaffiliationsdesc:
    'The settings for conducting transactions in your store, and the language and country settings for the interface displayed to customers',
  shopifyCurrencyConfirmBRL:
    'Please confirm that the currency in your Shopify store is set to BRL.',
  shopifyCurrencyConfirmCLP:
    'Please confirm that the currency in your Shopify store is set to CLP.',
  shopifyCurrencyConfirmCOP:
    'Please confirm that the currency in your Shopify store is set to COP.',
  shopifyCurrencyConfirmEUR:
    'Please confirm that the currency in your Shopify store is set to EUR.',
  shopifyCurrencyConfirmGBP:
    'Please confirm that the currency in your Shopify store is set to GBP.',
  shopifyCurrencyConfirmMXN:
    'Please confirm that the currency in your Shopify store is set to MXN.',
  shopifyCurrencyConfirmPEN:
    'Please confirm that the currency in your Shopify store is set to PEN.',
  shopifyCurrencyConfirmSEK:
    'Please confirm that the currency in your Shopify store is set to SEK.',
  shopifyDomainUsedByOtherStore:
    'This domain has been used by other shopify store, please change the status of any unused Shopify stores to "Inactive."',
  confirmStoreConnectedWiio:
    'Please confirm whether your store is connected to Wiio Dropshipping.',
  confirmStoreConnectedUsaDrop:
    'Please confirm whether your store is connected to USADrop Dropshipping.',
  paymentbtntext: 'To set up',
  paymentdoamin: 'Domain CNAME Resolve',
  paymentlanguage: 'Checkout Page Language',
  paymentoptions: 'Payment options',
  paymentoptionsdesc: 'The payment options accepted in your store.',
  paymenttitle: 'Configure the payment methods accepted in your store.',
  personalInformationVerification: 'Personal information verification',
  personalInformationVerificationSubTitle:
    'Information verification involves your mobile phone number.',
  phone: 'Phone Number',
  pixel: 'Pixel',
  pixelIDisRequired: 'Pixel ID is required',
  pixelTokenisRequired: 'Pixel Token is required',
  pixelexample:
    'Example: A customer sees your ad, visits your website and makes a purchase. Pixel tracks this, helping you know which ads drive the most sales.',
  pixelhelp:
    'Analyze the performance of your marketing campaigns, seeing how your customers interact with your ads and your store.',
  pixelid: 'Pixel lD',
  pixelname: 'Pixel name',
  pixeltoken: 'Pixel token',
  platforms: 'PLATFORMS',
  pleaseFillTheRequiredFields: 'Please fill the required fields',
  pleaseInput: 'Please Input',
  pleaseInputDomain: 'Please Input Domain',
  pleaseSelect: 'Please Select',
  pleaseSelectDate: 'Please select a date',
  pleconfirmPWD: 'Please confirm password',
  pleinputPWD: 'Please input password',
  popup: 'Popup',
  popupBackground: 'Popup Background',
  popupConfig: 'Popup Configuration',
  popupConfigDesc: 'Popup Display Effect and Popup Rules',
  popupCycle: 'Pop-up cycle',
  popupCycleItem: 'First-time user, pop-up every {input} days',
  preview: 'Preview',
  previousPage: 'Previous Page',
  priceTerms: 'Price Terms',
  privacypolicy: 'Privacy Policy',
  processingTime: `Party A will fulfill all orders from Party B's store and update the processing time, shipping time, product descriptions in Party B's store, etc. according to Party A's requirements. If there are adjustment items, such as out-of-stock products and similar products, Party B should complete the adjustment/removal within 12 hours.`,
  product: 'Product',
  productSpecifications:
    'Wrong product, color, size, other SPU, specifications, refunds are borne by Party A',
  productsImitation:
    'Imitation products_imitation brands, the refund shall be borne by Party B',
  propertyRights:
    'Uploading and selling products that infringe intellectual property rights is prohibited',
  protocolBtnPrefix: 'I agree to the',
  protocolBtnTitle: 'Payment Terms And Conditions and Privacy Policy',
  protocolDialog: 'User Agreement',
  questionsSupport:
    'If you have any questions, please use our support material listed below:',
  recommendSize: 'Recommended size: {input}',
  recoverpassowrd: 'Recover Password',
  recovertitle: 'Enter your email address below',
  rectifiedAccording: `For refunds of orders that are not rectified according to Party A's requirements, the refund shall be borne by Party B`,
  redirectLink: 'Redirect Link',
  refundGuaranteeFees: 'Refund Guarantee Fees',
  refundGuaranteeTerms: 'Refund Guarantee Terms',
  refundShallBe:
    'If the product is not reviewed and the product is out of stock, the refund shall be borne by Party B',
  refundsAreBorne:
    'Logistics information shows that it has not been delivered/updated for a long time, refunds are borne by Party A',
  refundsAreGiven:
    'The product has been reviewed, the product is out of stock and refunds are given to the customer, refunds are borne by Party A',
  register: 'Register',
  registersuccess: 'Register success!',
  registertips:
    'We will use your data to create your access account and send information that helps you activate your store.',
  requestNumber: 'ORDER NUMBER',
  requests: 'Order',
  requestsCancellation:
    'The order has not been shipped and the customer requests cancellation',
  save: 'Save',
  saveFields: 'After filling in the fields, save what you have filled in.',
  saveSuccessfully: 'Save successfully',
  search: 'Search',
  secondarydomains: 'Secondary domains',
  selectCountry: 'Select Country',
  selectTimeZone: 'Select Time Zone',
  service: 'Service',
  serviceemail: 'Customer Service Email',
  setUpDomain:
    'Set up your domain with your provider by following the steps below.',
  settings: 'Settings',
  settlementPeriod:
    'Extend the settlement period or suspend settlement; Party A has the right to terminate the Agreement and not return it to Party B. The unsettled amount and deposit will be settled at a different agreed time after six months.',
  shipped:
    'The order time is less than or equal to 3 days, the order has been shipped, and the customer requests to cancel and refund, and the refund shall be borne by Party B',
  shopify: 'Shopify',
  shopifybtntext: 'Install',
  shopifytitle: 'Install Transparent Checkout on your Shopify store.',
  skipshoppingcart: 'Skip shopping cart',
  specificRates: '3、Specific rates',
  specificUsageScenarios:
    'Refunds generated by other methods will be borne by Party A. For specific usage scenarios, click here to',
  sslCertificate: 'SSL CERTIFICATE',
  start: 'Start',
  startDate: 'Start date',
  startUsing: 'Active',
  startconfig: 'Start Configuring here',
  status: 'Status',
  step1Content:
    '"Go to your domain providers website. Look for the DNS records configuration section."',
  step1Title: '"STEP 1: ACCESS YOUR PROVIDERS PANEL"',
  step2Content:
    'In your provider, in the DNS records configuration section, add the information below. Fill in each field with the respective information listed below:',
  step2Title: '"STEP 2: ACCESS YOUR PROVIDERS PANEL"',
  step3Content:
    'After correctly completing the above entries with your domain provider, you must wait a while for the information to propagate. This process usually takes up to 4 hours.',
  step3Title: 'STEP 3: WAIT FOR PROPAGATION',
  storeAccessingUrl: 'Online Store Address',
  storeBinding: 'Connect store',
  storeBindingSettings: 'Store Settings',
  storeLogo: 'Store logo',
  checkoutLogoSizeTip: 'Recommended logo image size: 230 × 50 px',
  storeLogoLimitTips: 'Recommended size: 230*50, within 200 KB',
  orderImage: 'Store Order Volume - Last 30 Days',
  orderRemark: 'Order remark',
  orderImageLimitTips: 'Multiple images are supported',
  viewExample: 'View Example',
  storename: 'Store Name',
  termsofuse: 'terms of use',
  theCheckoutPage:
    'Discount Amount/Percent: On the checkout page, set a fixed discount amount/percent to attract customers to choose this payment method.',
  theProductsSold:
    'The products sold on the website include products that are not authorized by the brand or use trademarks that are not authorized by the brand, as well as other brand products; non-brand intellectual property infringement, including but not limited to: movies, videos, songs, games, animation works and their peripheral products, including but not limited to figurines, accessories, and character equipment.',
  theRefundShall:
    'If the customer receives the goods and the delivery time is too long and it does not exceed the store time limit, the refund shall be borne by Party B',
  timezone: 'Time Zone',
  tips: 'Tips',
  toEmbedPaymentMethods: 'To embed payment methods.',
  toenter: 'To enter',
  tosave: 'To save',
  total: 'Total',
  trackingNumber: 'Tracking Number',
  transactionSettlement:
    'Party B agrees that Party A will deduct the above fees from Party B’s transaction settlement amount.',
  transferPlatform: 'Order Transfer Platform',
  tutorial: 'Tutorial',
  type: 'TYPE:',
  typeofintegration: 'Type of integration',
  typepassword: 'Type your password',
  unauthorized:
    'For unauthorized transactions, the refund shall be borne by Party B',
  unauthorizedTransaction: 'Unauthorized transaction',
  unconvertedOrder: 'Unconverted Order',
  update: 'To update',
  urlDisplayed:
    'The URL displayed in the web browser when customers browse your online store is a custom domain name.',
  usedNormally: 'Cannot be used normally, refunds are borne by Party A',
  value: 'VALUE:',
  wantsToCancel: 'The customer buys more and wants to cancel and refund',
  whatisapixel: 'What is a Pixel?',
  whatsAppTemplate: 'WhatsApp Template',
  whichTimeZoneSetTitle: 'Which time zone should be set?',
  withdrawalFeeAnswer:
    'It depends on your fee of bank. Different banks have different fee.',
  withdrawalFeeTitle: 'What are the fees for withdrawals?',
  withdrawalMethodAnswer:
    'After paying the fulfillment cost, you can withdraw the wallet balance. Bank transfer and Paypal withdrawal are supported.',
  withdrawalMethodTitle:
    'How to withdraw cash and what are the withdrawal methods?',
  yes: 'Yes',
  mismatched: 'Party B',
  mustNotSell: 'must not sell any branded items,',
  brandIconsMust: `and brand icons must not appear in product descriptions. Once Party A finds that there is a branded illegal or mismatched product in Party B's store, Party A will suspend all payments to Party B's store within 6 hours and stop all payout. Party A shall have the right to process refunds for any non-compliant or violating orders, and all costs and expenses arising therefrom shall be borne solely by Party B. The specific fine amount is shown in`,
  theRefund: 'The refund guarantee service includes the following: ',
  refundGuarantee: 'Refund Guarantee Terms.',
  priceList: 'Price List',
  Holding: 'Holding',
  appendixTwo: 'Appendix 2.',
  paymentPriceList: 'Payment price list',
  howDoes: 'What is Dropshipping and How does it work',
  whatIsPayment: 'What is USAdrop Payment',
  differenceDropshipping:
    'The difference between Cash on delivery and Dropshipping',
  howsySterm: 'How to use USAdrop systerm',
  howShopifyAPI: 'How to set up shopify API',
  howDomain: 'How to set up Domain',
  howPixel: 'How to Set Up Facebook Pixel',
  howCoupon: 'How to set up Coupon',
  pleaseShopifyStore:
    'Please make sure the domain connect to your Shopify Store!',
  feeTerms: 'Fee Terms',
  noRefundGuarantee: 'No refund guarantee fee in Brazil',
  deleteShopify:
    'How to delete or add "Buy it Now" dynamic button and "add to cart" button in Shopify',
  stepOne: 'Step 1, navigate to "Online Store" → "Themes" → "Customize"',
  stepTwo:
    'Step 2 - Navigate to "Products" → "Default product" → enter the product description page',
  stepThree:
    'Step 3 - Click "Buy Buttons" → Click to turn on "Show dynamic checkout buttons" → "Save"',
  dynamicCheckoutButton: 'How to set up Dynamic checkout button',
  personalInformationTitle: 'My Account Information',
  personalInformationSubTitle:
    'Account information verification is a process of ensuring that your information is accurate and up-to-date. It involves verifying your phone number to ensure it is correct and up-to-date.',
  personalInformationTips:
    'Note: \n' +
    'In order to ensure the authenticity of your identity information, we need to verify your mobile' +
    ' phone' +
    ' number.The name and mobile phone number cannot be modified after verification and binding. If you cannot' +
    ' receive the verification code or need to modify it, please contact USAdrop payment customer service/agent.',
  contactName: 'Contact Name',
  contactPhone: 'Phone Number',
  contactPhoneAreaCode: 'Phone Area Code',
  getVerificationCode: 'GET VERIFICATION CODE',
  verificationCode: 'Verification Code',
  pleaseEnter: 'Please Enter {input}',
  pleaseSelect2: 'Please Select {input}',
  fulfillmentPlatform: 'Fulfillment Platform',
  pleaseEnterCorrect: 'Please input correct {input}',
  sendSuccessfully: 'Send successfully',
  submitSuccessfully: 'Submit successfully',
  serviceUnavailable: 'The service is unavailable',
  loginExpired: 'Login expired, please log in again',
  toVerification: 'To Verification',
  activeCustomerPaymentTips:
    'The personal information verification has not been completed yet, so the payment service cannot be used. ',
  activeCustomerPaymentTips2: `Please click "Personal information verification" to complete the personal information verification.`,
  skipCartTips1:
    'This feature helps increase single-order conversion rates , but reduce add-to-cart rates. Enable' +
    ' it as needed.',
  skipCartTips2: `When activated, USAdrop Payment will disable Shopify’s "Add to Cart"
            button and retain only the dynamic checkout buttons. Customers
            clicking these buttons will be directed straight to the checkout
            page.`,
  skipCartTips3:
    '(If the checkout button is not visible on product pages after enabling this feature, follow the' +
    ' tutorial to activate dynamic checkout buttons:',
  advertisingMaterial: 'Advertising material tutorial',
  violationRecord: 'Violation Records',
  store: 'Store',
  state: 'State',
  deadline: 'Deadline',
  needModified: 'Need to be modified',
  reviewing: 'Reviewing',
  completed: 'Completed',
  types: 'Type',
  picture: 'Picture',
  details: 'Details',
  overdue: 'Overdue',
  rejected: 'Rejected',
  operate: 'Operate',
  complete: 'Complete',
  completeTips:
    'We are about to submit for review, please ensure that the modifications have been completed as required!',
  remark: 'Remark',
  remarkPlaceholder: 'Please enter remark',
  pleaseInputRemark: 'Please fill in the remark',
  facebookPixel: 'How to set up Facebook Pixel?',
  googlePixel: 'How to set up Google Pixel?',
  themeColor: 'Theme Color',
  themeColorTips:
    'You can use this setting to modify the theme color of the "checkout" interface.',
  buttonColor: 'Buy Now Color',
  buttonColorTips:
    'You can use this setting to change the color of the "Buy Now" button.',
  terminationAgreement: 'Termination of Agreement',
  installment: 'Installment',
  unhandledStores: 'You have illegal stores',
  pixelTop1: "GTM is already linked. You can't add another pixel.",
  pixelTop2: 'Turn off the current pixel before using GTM.',
  pixelTop3:
    "GTM and other pixels can't work at the same time. Need help? Contact your agent.",
  successVideoTop: 'Real Success Stories',
  paypalTop: 'Please contact our agent to active Paypal payment.',
  errorMessage: 'Server error occurred',
  wiioRechargeTitle: 'Reminder',
  wiioRechargeDesc: 'Please pay the monthly fee to use the platform.',
  wiilRechargeConfirm: 'Go to USAdrop',
  orderPageDesigner: 'Checkout Editor',
  export: 'Export',
  exporting: 'Exporting...',
  unknownError: 'Unknown error',
  downloadSuccess: 'Download successful',
  defaultExportNotice:
    'By default, logs from the last 30 days will be exported; you can select a maximum range of 30 days',
  pageStyleConfig: 'Page Style Configuration',
  pageText: 'Page Text',
  restoreDefaults: 'Restore defaults',
  footerText: 'Footer Text',
  browserTabTitle: 'Browser Tab Title',
  footerShopName: 'Footer Shop Name',
  footerShopNameHint: 'Leave blank to use the current shop name.',
  browserTabTitleHint: 'Leave blank to use the store name.',
  footerTextHint: 'Set text for each checkout language. Leave blank to use the default.',
  reset: 'Reset',
  limitedTimeOffer: 'Limited-time offer! Order now to enjoy the discount!',
  countdownToEnd: 'Time until the event ends:',
  configLoadedSuccess: 'Configuration data loaded successfully',
  configLoadedUseDefault:
    'Failed to load configuration data, using default values',
  configLoadFailed:
    'Failed to fetch configuration, please check network or service',
  confirmRestore:
    'Are you sure you want to restore the configuration? This action is irreversible',
  warning: 'Warning',
  confirmReset: 'Confirm reset',
  submitSuccess: 'Submitted successfully',
  checkoutConfigSaved:
    'Checkout page configuration saved and applied successfully!',
  saveConfigFailed: 'Failed to save configuration, please try again later.',
  visualSizeConfig: 'Visual & Size Configuration',
  width: 'Width',
  height: 'Height',
  textAndCountdownConfig: 'Text & Countdown Configuration (Marketing Copy)',
  textContent: 'Text Content',
  enterMarketingCopy: 'Please enter marketing copy',
  fontSize: 'Font Size',
  fontColor: 'Font Color',
  fontWeight: 'Font Weight',
  selectWeight: 'Select weight',
  countdownSettings: 'Countdown Settings',
  enableCountdown: 'Enable countdown',
  countdownPrefix: 'Countdown prefix',
  examplePrefix: 'Example: Until end',
  endTime: 'End Time',
  selectEndTime: 'Select countdown end time',
  textSpacing: 'Text/Timer Spacing',
  realtimePreview: 'Real-time Preview',
  eventEnded: 'The event has ended',
  rowInfo: 'Row {index} Information',
  icon: 'Icon',
  title: 'Title',
  bottomTextConfig: 'Bottom Text Configuration',
  text: 'Text',
  suggestedSize: 'Suggested size',
  logo: 'Logo',
  banner: 'Banner',
  safetyInfo: 'Safety Information',
  securityIcons: 'Security Icons',
  description: 'Description',
  confirmSavePageStyle:
    'Are you sure you want to save the current page style configuration? Once saved, it will take effect on the checkout page immediately.',
  getCodeTip: 'Please complete Shop Domain, API Key and Secret Key first.',
  getCode: 'Get Code',
  token_helper_tip:
    'Get Access Token automatically via Dev Dashboard credentials.',
  copySuccess: 'Copied!',
  paymentDetails: 'Payment details',
  viewPaymentCode: 'Payment Code',
  paymentLink: 'Payment link',
  paymentCodeDetails: 'Payment code',
  barcode: 'Barcode',
  pixPaymentCode: 'PIX payment code',
  copyPaymentCode: 'Copy payment code',
  downloadPaymentImage: 'Download image',
  paymentCodeValidUntil: 'Valid until',
  paymentImageUnavailable: 'Unable to generate the payment image.',
  copyFailed: 'Unable to copy. Please select and copy the code manually.',
  pleaseFillInClientIdAndSecret:
    'Please fill in Client ID (API Key) and Secret (API Secret Key)',
  pleaseEnterClientIdAndSecret:
    'Please enter Client ID (API Key) and Secret (API Secret Key)',
  pleaseFillInClientIdAndSecretFirst:
    'Please fill in Client ID (API Key) and Secret (API Secret Key) first',
  pleaseContactAgent: 'Please contact agent',
  createStoreMexicoUSAdropPaymentsTitle: 'Build Your Shopify Store from 0',
  couponDisplayConfig: 'Coupon Display',
  displayMode: 'Display Mode',
  couponDisplayExpand: 'Expand',
  couponDisplayHide: 'Hide',
  couponHideModeTipStart:
    'When enabled, the coupon input field is hidden by default. If you have configured a',
  couponHideModeTipEnd:
    'and it is active, it will be applied automatically when a customer places a second order. If you do not want customers to use discount codes, please set the coupon status to "Disabled".',
  couponDisplayCollapse: 'Collapse',
  couponUnselected: 'Unselected',
  couponNoAvailable: 'No available coupons',
  couponNoCode: 'No need to fill in',
  productPrice: 'Product',
  productDiscount: 'Discount',
  productShipping: 'Shipping',
  free: 'Free',
  apply: 'Apply',
  orderPreviewPriceProduct: '$9999.00',
  orderPreviewPriceDiscount: '-$0.00',
  orderPreviewPriceTotal: '$9999.00',
  uponTransactionRisks: `Upon the consumer's submission of a refund request, Party A reserves the right to process a refund for the transaction in order to mitigate more severe transaction risks.`,
  howGooglePixel: 'How to set up Google pixel',
  fulfillmentPlatformTips: 'Important: Merchants using our payment solution are required to fulfill orders through our fulfillment service.',
  shippingCalculation: 'Enable Shipping Calculation',
  shippingCalculationTips: 'Calculate and validate shipping costs during checkout.'
}
